'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var cx = require('classnames');
var Downshift = require('downshift');
var AlloyButton = require('../alloy-button/AlloyButton.js');
var ErrorMessage = require('../alloy-input/ErrorMessage.js');
var Label = require('../alloy-input/Label.js');
var DropdownMenu = require('./DropdownMenu.js');
var alloyDropdown_module = require('./alloy-dropdown.module.scss.js');
var ArrowUpIcon = require('../alloy-icon/ArrowUpIcon.js');
var ArrowDownIcon = require('../alloy-icon/ArrowDownIcon.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var cx__default = /*#__PURE__*/_interopDefault(cx);

var MultiItemDropdown = function (_a) {
    var _b;
    var _c = _a.className, className = _c === void 0 ? '' : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d; _a.error; var items = _a.items, icon = _a.icon, itemToString = _a.itemToString, keyToString = _a.keyToString, titleToString = _a.titleToString, label = _a.label, menuSize = _a.menuSize, onBlur = _a.onBlur, onClick = _a.onClick, onError = _a.onError, name = _a.name, onFocus = _a.onFocus, placeholder = _a.placeholder; _a.showOptional; _a.showRequired; var validator = _a.validator; _a.id; var getLabel = _a.getLabel, internalOnChange = _a.internalOnChange, setInternalError = _a.setInternalError, internalError = _a.internalError, internalSelected = _a.internalSelected, labelClassName = _a.labelClassName, props = tslib.__rest(_a, ["className", "disabled", "error", "items", "icon", "itemToString", "keyToString", "titleToString", "label", "menuSize", "onBlur", "onClick", "onError", "name", "onFocus", "placeholder", "showOptional", "showRequired", "validator", "id", "getLabel", "internalOnChange", "setInternalError", "internalError", "internalSelected", "labelClassName"]);
    var ref = react.useRef();
    var _e = react.useState(false), hasFocus = _e[0], setHasFocus = _e[1];
    var dataCsMask = props['data-cs-mask'];
    var getIcon = function (isOpen) {
        return isOpen ? (jsxRuntime.jsx(ArrowUpIcon.default, { className: "alloy-dropdown-arrow float-end ".concat(alloyDropdown_module.default['fill-color']) })) : (jsxRuntime.jsx(ArrowDownIcon.default, { className: "alloy-dropdown-arrow float-end ".concat(alloyDropdown_module.default['fill-color']) }));
    };
    var onSelectedItemChange = function (change) {
        // Allow users to 'clear' their selection if placeholder is provided
        var newVal = placeholder && change === placeholder ? '' : change;
        internalOnChange(newVal);
        if (validator) {
            var result = validator(newVal);
            setInternalError(result);
        }
        else {
            setInternalError();
        }
    };
    var handleOnBlur = function (e) {
        setHasFocus(false);
        if (onBlur) {
            onBlur(e);
        }
    };
    var handleOnFocus = function (e) {
        setHasFocus(true);
        if (onFocus) {
            onFocus(e);
        }
    };
    var normalizedMenuItems = placeholder
        ? tslib.__spreadArray([placeholder], items, true) : items;
    var _f = Downshift.useSelect(tslib.__assign({ items: normalizedMenuItems, itemToString: itemToString, onSelectedItemChange: function (item) {
            onSelectedItemChange(item.selectedItem);
        }, selectedItem: internalSelected, name: name }, props)), getItemProps = _f.getItemProps, getMenuProps = _f.getMenuProps, getToggleButtonProps = _f.getToggleButtonProps, getLabelProps = _f.getLabelProps, _g = _f.isOpen, isOpen = _g === void 0 ? false : _g, downshiftId = _f.id, selectedItem = _f.selectedItem, highlightedIndex = _f.highlightedIndex;
    var shouldDisplayErrors = !isOpen && !hasFocus && internalError;
    var buttonStyles = cx__default.default('w-100 text-start d-flex align-items-center', alloyDropdown_module.default['text-transform-none'], (_b = {
            'dropdown-invalid': shouldDisplayErrors
        },
        _b[alloyDropdown_module.default['dropdown-error']] = shouldDisplayErrors,
        _b));
    return (jsxRuntime.jsxs("div", tslib.__assign({ ref: ref, className: "mb-3 dropdown-container" }, { children: [jsxRuntime.jsxs("div", tslib.__assign({ className: cx__default.default('dropdown', className) }, { children: [label && (jsxRuntime.jsx(Label.default, tslib.__assign({}, getLabelProps(), { className: cx__default.default(alloyDropdown_module.default['dropdown__label'], labelClassName), fieldId: downshiftId }, { children: getLabel() }))), jsxRuntime.jsxs(AlloyButton.AlloyButton, tslib.__assign({ id: downshiftId, buttonType: "dropdown", size: "large", className: buttonStyles }, getToggleButtonProps({
                        onBlur: handleOnBlur,
                        onClick: onClick,
                        onFocus: handleOnFocus,
                        name: name
                    }), { disabled: disabled }, { children: [jsxRuntime.jsx("span", tslib.__assign({ className: "text-truncate d-block flex-grow-1 ".concat(alloyDropdown_module.default['span-fix'], " m-0 ").concat(selectedItem ? '' : alloyDropdown_module.default['placeHolderColor']), "data-cs-mask": dataCsMask }, { children: selectedItem
                                    ? itemToString(selectedItem)
                                    : itemToString(placeholder) })), jsxRuntime.jsx("span", tslib.__assign({ className: "".concat(alloyDropdown_module.default['span-fix'], " m-0") }, { children: getIcon(isOpen) }))] })), jsxRuntime.jsx(DropdownMenu.default, { highlightedIndex: highlightedIndex, dataCsMask: dataCsMask, placeholder: placeholder, items: normalizedMenuItems, itemToString: itemToString, getItemProps: getItemProps, getMenuProps: getMenuProps, isOpen: isOpen, keyToString: keyToString, titleToString: titleToString, selectedItem: selectedItem, menuSize: menuSize, icon: icon })] })), shouldDisplayErrors && (jsxRuntime.jsx(ErrorMessage.default, tslib.__assign({ fieldName: name, inputRef: ref, onShow: onError }, { children: internalError })))] })));
};
var MultiItemDropdown$1 = MultiItemDropdown;

exports.default = MultiItemDropdown$1;
//# sourceMappingURL=MultiItemDropdown.js.map
